import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const CalBurnedIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 41 56" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75598 18.0647C6.75598 21.5531 7.73484 29.0033 11.6503 30.8969C9.52943 23.7126 8.81159 7.47507 22.9072 0C21.6021 2.36711 20.5824 8.42191 26.945 13.7043C27.7724 14.3912 28.5984 15.0498 29.4113 15.6979C36.4123 21.2796 42.4364 26.0825 39.9149 41.4866C34.0418 58.5547 15.8105 58.1809 9.3255 52.4501C2.84053 46.7192 -5.4388 33.5132 6.75598 18.0647ZM22.0507 42.9816C25.8846 40.3238 32.0106 32.2175 25.8438 21.0548C29.229 22.1345 35.9506 26.8355 35.7548 37.0016C35.5101 49.7092 18.0129 54.3188 10.5491 45.2242C13.6896 44.7674 20.5579 41.8106 22.9072 33.6378C23.1927 34.8421 23.4211 38.3969 22.0507 42.9816Z"
        fill="#F27373"
      />
    </SvgIcon>
  );
};

export default CalBurnedIcon;
